module.exports = __webpack_public_path__ + "img/2_15.c610b089.png";